import { render } from "./MyProdotto.vue?vue&type=template&id=1db9ba0a"
import script from "./MyProdotto.vue?vue&type=script&lang=js"
export * from "./MyProdotto.vue?vue&type=script&lang=js"

import "./MyProdotto.vue?vue&type=style&index=0&id=1db9ba0a&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__